import ProTable from './src/main'

ProTable.install = function (Vue) {
  Vue.component(ProTable.name, ProTable)
}

export default ProTable
